<template>
  <CommonLayout footer="floristFooter">
    <FloristHeader @suggestion="suggestion"></FloristHeader>
    <MeetingLayout :type="this.consts.meetingType.florist">
      <div class="base-color mh-550 shadow">
        <b-overlay :show="overlayShow" rounded="sm">
          <div class="p-2">
            <div class="col-sm-12 row">
              <div class="col-sm-6 p-3">
                <span>画像を選択してください。</span>
              </div>
              <div class="col-sm-6 text-right p-3">
                <!--<b-button variant="outline-primary" class="sub-button-color" @click="backPage" id="back" v-if="isProjectTypeMain">&lt;&nbsp;戻る</b-button>-->
                <!--<b-button variant="outline-primary" class="ml-3 sub-button-color" @click="reload" id="reload">更新</b-button>-->
              </div>
            </div>
            <div class="col-sm-12">
              <div class="card-columns p-3 w-100 production-col-cnt" v-for="(styleImages, index) in suggestionProductData()" :key="index">
                <div class="card position-relative border-0 bg-unset card-sqr-gray" v-for="(styleImage, i) in styleImages" :key="i">
                  <div class="p-0 h-100" @click="nextPage(styleImage.projectNumber)">
                    <img :src="styleImage.imagePath" class="ar-3-2" :ref="index + '-' + i">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import CommonModal from '@/components/CommonModal'
import CommonLayout from '@/layout/CommonLayout'
import MeetingLayout from '@/layout/MeetingLayout'
import FloristHeader from '@/components/FloristHeader.vue'
import SuggestionProductModel from '@/models/SuggestionProductModel'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import mstore from '@/store/meeting-store'
import fstore from '@/store/florist-store'

export default {
  name: 'FloristMeetingProductProposal',
  components: { CommonModal, CommonLayout, MeetingLayout, FloristHeader },
  data () {
    return {
      overlayShow: false,
      imageRowMaxNum: 2,
      isSendFirstSignalingData: false,
      isProjectTypeMain: false
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
    },
    getSignalingData: function (newData, oldData) {
      try {
        console.log(newData)
        console.log(oldData)
        if (newData['event'] !== 'api') {
          newData['user'] = 'florist'
          newData['timestampMs'] = Date.now()
          CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
          })
        }
        if (newData['event'] === 'again') {
          // 情報の再送要求が来たら画面の情報を再送する
          this.sendSignalingApiData()
          return null
        }
        if (newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('customer', 'florist')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }
        if (!fstore.getters.isOperationPossible) {
          if (newData['event'] === 'click' && newData['id'] === 'next') {
            // 商品一覧画面から遷移する際にスクロール位置を記憶
            sessionStorage.setItem('scrollY', window.scrollY)
            sessionStorage.setItem('proposalScrollHistoryFlag', 'True')
            this.$router.push(newData['target_path'])
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'errorMessage': err.message}, () => {
        })
      }
    }
  },
  methods: {
    suggestionProductData () {
      const store = SuggestionProductModel.getStore()
      if (!store) {
        return null
      }
      const length = Math.ceil(store.images.length / this.imageRowMaxNum)
      return new Array(length).fill().map((_, i) =>
        store.images.slice(i * this.imageRowMaxNum, (i + 1) * this.imageRowMaxNum)
      )
    },
    setApiData: async function (isReload = false) {
      console.log('start setApiData')
      this.overlayShow = true
      if (localStorage.getItem('suggestionData') === null) {
        return this.$refs.commonModal.msgBoxOk('提案条件を設定してください')
      }
      const currentProjectType = JSON.parse(localStorage.getItem('suggestionData')).projectType[0]
      if (this.consts.projectType.finish.indexOf(currentProjectType) !== -1) {
        return this.$router.push('/florist/meeting/estimate')
      }
      console.log('setApiData set params')
      let params = {}
      params = JSON.parse(localStorage.getItem('suggestionData'))
      try {
        console.log('setApiData apiSetStore')
        await SuggestionProductModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        console.log('setApiData apiSetStore end')
      } catch (e) {
        return false
      }
      console.log('setApiData indexOf')
      this.isProjectTypeMain = this.consts.projectType.main.indexOf(currentProjectType) !== -1
      if ((!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) || isReload) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
      console.log('end setApiData')
    },
    sendSignalingApiData () {
      const store = SuggestionProductModel.getStore()
      if (!store) {
        return null
      }
      let apiRes = {}
      let apiResponse = []
      const suggestionType = JSON.parse(localStorage.getItem('suggestionData')).suggestionType ? JSON.parse(localStorage.getItem('suggestionData')).suggestionType[0] : ''
      const count = store.images.length
      for (let i = 0; i < count; i++) {
        apiRes = {
          'status': store.status,
          'message': store.message,
          'images': store.images[i],
          'imageSort': i,
          'project_type': JSON.parse(localStorage.getItem('suggestionData')).projectType[0],
          'suggestion_type': suggestionType
        }
        apiResponse.push(apiRes)
        // 3つずつまとめてシグナリングを送るようにする
        if ((i + 1) % 3 === 0 || i === count - 1) {
          SignalingModel.sendApiEvent('getSuggestionProduct', this, apiResponse)
          apiResponse = []
        }
      }
    },
    nextPage (projectNumber) {
      // 操作可能時のみ
      if (fstore.getters.isOperationPossible) {
        // 商品一覧画面から遷移する際にスクロール位置を記憶
        sessionStorage.setItem('scrollY', window.scrollY)
        sessionStorage.setItem('proposalScrollHistoryFlag', 'True')
        const targetPath = '/florist/meeting/product_selection/' + projectNumber
        const suggestionType = JSON.parse(localStorage.getItem('suggestionData')).suggestionType ? JSON.parse(localStorage.getItem('suggestionData')).suggestionType[0] : ''
        this.$router.push({path: targetPath, query: {'projectType': JSON.parse(localStorage.getItem('suggestionData')).projectType[0], 'suggestionType': suggestionType}})
        SignalingModel.sendClickEvent('next', this, {
          'target_path': targetPath.replace('florist', 'customer'),
          'project_number': projectNumber
        })
      }
    },
    backPage () {
      const targetPath = '/florist/meeting/style_image_proposal'
      SignalingModel.sendClickEvent('back', this, {'target_path': targetPath.replace('florist', 'customer')})
      this.$router.push(targetPath)
    },
    reload () {
      SignalingModel.sendClickEvent('reload', this)
      this.setApiData(true)
    },
    suggestion () {
      window.scrollTo(0, 0)
      const currentProjectType = JSON.parse(localStorage.getItem('suggestionData')).projectType[0]
      if (this.consts.projectType.finish.indexOf(currentProjectType) !== -1) {
        this.$router.push('/florist/meeting/estimate')
      } else {
        SignalingModel.sendClickEvent('reload', this)
        this.setApiData(true)
      }
    }
  },
  async mounted () {
    console.log('setApiData')
    await this.setApiData()
    if (sessionStorage.getItem('proposalScrollHistoryFlag') === 'True') {
      console.log('proposalScrollHistoryFlag')
      console.log(sessionStorage.getItem('proposalScrollHistoryFlag'))
      // 商品一覧画面を表示した履歴フラグが残っており、スクロール位置が保存されている場合
      // 保存した位置に画面をスクロールさせる
      if (sessionStorage.getItem('scrollY') !== null) {
        window.scrollTo(0, sessionStorage.getItem('scrollY'))
      }
    } else {
      window.scrollTo(0, 0)
    }
  },
  destroyed () {
    if (SuggestionProductModel.getStore()) {
      SuggestionProductModel.removeStore()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/FloristMeetingProductProposal.vue